import { mobMenu } from './nav-menu';
import { imageSwiper } from './swipers';
import { historyScroll } from './history';
import { initTabs } from './tabs';
import { appearFromSide, appearOnScreen, appearOnScreenContainer, statBars, statNumbers } from './in-view-animations';
import { initModals } from './modals';
import { companyFilter } from './companies';

// REMOVE 'HIDDEN' CLASS FROM SUB-MENUS TO PREVENT ANIMATION TRANSITION ON PAGE LOAD
document.querySelectorAll('.main-nav-mobile').forEach(menu => {
    menu.classList.remove('hidden');
})

mobMenu();

document.querySelector('.image-swiper') && imageSwiper();

document.querySelector('.js-tab-btn') && initTabs();

document.querySelector('.js-appear-on-screen') && appearOnScreen();

document.querySelector('.js-appear-on-screen-container') && appearOnScreenContainer();

(document.querySelector('.js-slide-in-l') || document.querySelector('.js-slide-in-r')) && appearFromSide();

document.querySelector('.modal') && initModals();

document.querySelector('.companies') && companyFilter();

document.querySelector('.year') && historyScroll();

// const langMenuBtn = document.querySelector('.lang-menu-btn');
// const langList = document.querySelector('.lang-menu-list');

// langMenuBtn.addEventListener('click', () => {
//     langList.classList.toggle('active');

//     document.addEventListener('click', (e) => {
//         let closestLangList = e.target.closest('.lang-menu-list');
//         let closestLangBtn = e.target.closest('.lang-menu-btn');

//         if (!closestLangList && !closestLangBtn) {
//             langList.classList.contains('active') && langList.classList.remove('active');
//         }

//     });
// })